// Tallies the `data-counter-label` descendants of its element and pushes the
// counts to the server as `data-counter-event`, keyed by the element id. Generic
// (not conflict-specific) — any view can use it to count labelled child elements.
const ElementCounter = {
  mounted() {
    // Re-count on demand. `updated()` only fires when LiveView patches this
    // element. A diff that changes just one child LiveComponent is patched at
    // that component, so it never walks up to here. A view whose counted
    // elements live in a child LiveComponent therefore has to push this event
    // from that component — otherwise the tally keeps the old number while the
    // page shows the new one.
    this.handleEvent("recount_elements", () => this.count());
    this.count();
  },
  updated() {
    this.count();
  },
  destroyed() {
    const event = this.el.dataset.counterEvent;
    if (event) this.pushEvent(event, { id: this.el.id, counts: {} });
  },
  count() {
    const counts = {};
    this.el.querySelectorAll("[data-counter-label]").forEach((el) => {
      const label = el.dataset.counterLabel;
      counts[label] = (counts[label] || 0) + 1;
    });
    const event = this.el.dataset.counterEvent;
    if (event) this.pushEvent(event, { id: this.el.id, counts });
  },
};

export default ElementCounter;
